<template>
    <div>
        <!-- >>> 'Flight' Part (OUT/RET) -->
        <template v-if="modulo === 'booking'">
            <h2 v-if="flightdirection === 'outward'">{{ tab_header_flightdetailsoutward[getCurrentLocale] }}:</h2> <!-- out -->
            <h2 v-if="flightdirection === 'return'">{{ tab_header_flightdetailsreturn[getCurrentLocale] }}:</h2> <!-- ret -->
        </template>
        <template v-if="modulo === 'services'">
            <h2 v-if="flightdirection === 'outward'">{{ tab_header_flightdetailsoutwardservices[getCurrentLocale] }}:</h2> <!-- out -->
            <h2 v-if="flightdirection === 'return'">{{ tab_header_flightdetailsreturnservices[getCurrentLocale] }}:</h2> <!-- ret -->
        </template>


        <div class="intro table-wrapper full-width hidden-table-sm box" style="border-spacing: 8px;" v-if="modulo === 'booking'">
            <div class="col-md-4 table-cell sdr-box">
                <dl class="term-description">
                    <dt>{{ airline[getCurrentLocale] }}:</dt><dd></dd>
                    <dt>{{ flighttype[getCurrentLocale] }}:</dt><dd>Economy</dd>
                    <!-- <dt>{{ cancellation[getCurrentLocale] }}:</dt><dd>{{ avgpers[getCurrentLocale] }}/{{ 65 | rndAmntRUAFWZ }}</dd>
                    <dt>{{ flightchange[getCurrentLocale] }}:</dt><dd>{{ avgpers[getCurrentLocale] }}/{{ 65 | rndAmntRUAFWZ }}</dd> -->
                    <!-- <dt>{{ seatsandbaggage[getCurrentLocale] }}:</dt><dd>{{ extracharge[getCurrentLocale] }}</dd> -->
                </dl>
            </div>
            <div class="col-md-8 table-cell">
                <div class="detailed-features booking-details">
                    <div class="sdr-box">
                        <a href="#" class="button btn-mini yellow pull-right" v-if="flightdirection === 'outward'">STOPS: {{ getBookingLockfaresResults.outwardFlight.stopAirport === null ? '0' : '1' }}</a> <!-- out -->
                        <a href="#" class="button btn-mini yellow pull-right" v-if="flightdirection === 'return'">STOPS: {{ getBookingLockfaresResults.outwardFlight.stopAirport === null ? '0' : '1' }} </a> <!-- ret -->
                        <h4 class="box-title" v-if="flightdirection === 'outward'">{{ from[getCurrentLocale] }} {{ getBookingDepArprtName }} {{ to[getCurrentLocale] }}  {{ getBookingDesArprtName }}<small>{{ outwardflight[getCurrentLocale] }}</small></h4> <!-- out -->
                        <h4 class="box-title" v-if="flightdirection === 'return'">{{ from[getCurrentLocale] }} {{ getBookingDesArprtName }} {{ to[getCurrentLocale] }}  {{ getBookingDepArprtName }}<small>{{ returnflight[getCurrentLocale] }}</small></h4> <!-- ret -->
                    </div>
                    <div class="table-wrapper flights">
                        <div class="table-row first-flight">
                            <div class="table-cell logo">
                                <img src="/res/images/sdr140x30.png" alt="" style="padding-bottom:3px;">
                                <label v-if="flightdirection === 'outward'">{{ getBookingLockfaresResults.outwardFlight.flightNo }}</label> <!-- out -->
                                <label v-if="flightdirection === 'return'">{{ getBookingLockfaresResults.inboundFlight.flightNo }}</label> <!-- ret -->
                            </div>
                            <div class="table-cell timing-detail">
                                <div class="timing">
                                    <div class="check-in">
                                        <label>{{ takeoff[getCurrentLocale] }}</label>
                                        <span v-if="flightdirection === 'outward'">{{ getBookingCart[0].outward.depDT | dateFlightCart }}, {{ getBookingCart[0].outward.depDT | momentTime }}</span> <!-- out -->
                                        <span v-if="flightdirection === 'return'">{{ getBookingCart[0].return.depDT | dateFlightCart }}, {{ getBookingCart[0].return.depDT | momentTime }}</span> <!-- ret -->
                                    </div>
                                    <div class="duration text-center">
                                        <i class="soap-icon-clock"></i>
                                        <span v-if="flightdirection === 'outward'">{{ getBookingCart[0].outward.dur | durationFlightCart }}</span> <!-- out -->
                                        <span v-if="flightdirection === 'return'">{{ getBookingCart[0].return.dur | durationFlightCart }}</span> <!-- ret -->
                                    </div>
                                    <div class="check-out">
                                        <label>{{ landing[getCurrentLocale] }}</label>
                                        <span v-if="flightdirection === 'outward'">{{ getBookingCart[0].outward.desDT | dateFlightCart }}, {{ getBookingCart[0].outward.desDT | momentTime }}</span> <!-- out -->
                                        <span v-if="flightdirection === 'return'">{{ getBookingCart[0].return.desDT | dateFlightCart }}, {{ getBookingCart[0].return.desDT | momentTime }}</span> <!-- out -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="intro table-wrapper full-width hidden-table-sm box" style="border-spacing: 8px;" v-if="modulo === 'services'">
            <div class="col-md-4 table-cell sdr-box">
                <dl class="term-description">
                    <dt>{{ airline[getCurrentLocale] }}:</dt><dd></dd>
                    <dt>{{ flighttype[getCurrentLocale] }}:</dt><dd>Economy</dd>
                    <!-- <dt>{{ cancellation[getCurrentLocale] }}:</dt><dd>{{ avgpers[getCurrentLocale] }}/{{ 65 | rndAmntRUAFWZ }}</dd>
                    <dt>{{ flightchange[getCurrentLocale] }}:</dt><dd>{{ avgpers[getCurrentLocale] }}/{{ 65 | rndAmntRUAFWZ }}</dd> -->
                    <!-- <dt>{{ seatsandbaggage[getCurrentLocale] }}:</dt><dd>{{ extracharge[getCurrentLocale] }}</dd> -->
                </dl>
            </div>
            <div class="col-md-8 table-cell">
                <div class="detailed-features booking-details">
                    <div class="sdr-box">
                        <!-- <a href="#" class="button btn-mini yellow pull-right" v-if="flightdirection === 'outward'">STOPS: {{ getBookingLockfaresResults.outwardFlight.stopAirport === null ? '0' : '1' }}</a> out -->
                        <!-- <a href="#" class="button btn-mini yellow pull-right" v-if="flightdirection === 'return'">STOPS: {{ getBookingLockfaresResults.outwardFlight.stopAirport === null ? '0' : '1' }} </a> ret -->
                        <h4 class="box-title" v-if="flightdirection === 'outward'">{{ from[getCurrentLocale] }} {{ getBookingDepArprtName }} {{ to[getCurrentLocale] }}  {{ getBookingDesArprtName }}<small>{{ outwardflight[getCurrentLocale] }}</small></h4> <!-- out -->
                        <h4 class="box-title" v-if="flightdirection === 'return'">{{ from[getCurrentLocale] }} {{ getBookingDesArprtName }} {{ to[getCurrentLocale] }}  {{ getBookingDepArprtName }}<small>{{ returnflight[getCurrentLocale] }}</small></h4> <!-- ret -->
                    </div>
                    <div class="table-wrapper flights">
                        <div class="table-row first-flight">
                            <div class="table-cell logo">
                                <img src="/res/images/sdr140x30.png" alt="" style="padding-bottom:3px;">
                                <!-- <label v-if="flightdirection === 'outward'">{{ getBookingLockfaresResults.outwardFlight.flightNo }}</label> out -->
                                <!-- <label v-if="flightdirection === 'return'">{{ getBookingLockfaresResults.inboundFlight.flightNo }}</label> ret -->
                            </div>
                            <div class="table-cell timing-detail">
                                <div class="timing">
                                    <div class="check-in">
                                        <label>{{ takeoff[getCurrentLocale] }}</label>
                                        <span v-if="flightdirection === 'outward'">{{ getBookingCart[0].outward.depDT | dateFlightCart }}, {{ getBookingCart[0].outward.depDT | momentTime }}</span> <!-- out -->
                                        <span v-if="flightdirection === 'return'">{{ getBookingCart[0].return.depDT | dateFlightCart }}, {{ getBookingCart[0].return.depDT | momentTime }}</span> <!-- ret -->
                                    </div>
                                    <div class="duration text-center">
                                        <i class="soap-icon-clock"></i>
                                        <span v-if="flightdirection === 'outward'">{{ getBookingCart[0].outward.dur | durationFlightCart }}</span> <!-- out -->
                                        <span v-if="flightdirection === 'return'">{{ getBookingCart[0].return.dur | durationFlightCart }}</span> <!-- ret -->
                                    </div>
                                    <div class="check-out">
                                        <label>{{ landing[getCurrentLocale] }}</label>
                                        <span v-if="flightdirection === 'outward'">{{ getBookingCart[0].outward.desDT | dateFlightCart }}, {{ getBookingCart[0].outward.desDT | momentTime }}</span> <!-- out -->
                                        <span v-if="flightdirection === 'return'">{{ getBookingCart[0].return.desDT | dateFlightCart }}, {{ getBookingCart[0].return.desDT | momentTime }}</span> <!-- out -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <<< 'Flight' Part (OUT/RET) -->


        <!-- >>> 'Pax&Srvcs' Part (OUT/RET) -->
        <div class="booking-section sdr-box" style="padding:0px; padding-top: 10px;" v-for="(pax, index) in getBookingCart" v-bind:key="index">
            <h4 class="paxheadline">{{ trnslPaxTypes(pax.type) }} {{ pax.counter }}: {{ trnslPaxSalutations(pax.paxCredentials.salutation) }} {{ pax.paxCredentials.firstName }} {{ pax.paxCredentials.lastName }} ({{ born[getCurrentLocale] }}: {{ pax.paxCredentials.birthdate | birthdate }})</h4>
            <div class="table-cell cruise-itinerary">
                <div class="sdr-box" style="padding-top: 0px; padding-bottom:0px; padding-left: 0px; padding-right: 0px;">
                    <table v-if="flightdirection === 'outward'"> <!-- out -->
                        <tbody>
                            <tr> <!-- out flight  -->
                                <td v-if="modulo === 'booking'">{{ flightprice[getCurrentLocale] }}</td>
                                <td v-if="modulo === 'services'">{{ flightpriceservices[getCurrentLocale] }}</td>
                                <td>&nbsp;</td>
                                <td class="total-price-value-small" v-if="modulo === 'booking'">{{ pax.outward.totalprice !== undefined ? pax.outward.totalprice : '0' | rndAmntRUAFWZ }}</td>
                                <td class="total-price-value-small" v-if="modulo === 'services'"> - </td>
                            </tr>

                            <tr v-if="pax.outward_seat.seatno !== undefined"> <!-- out seat  -->
                                <td>{{ seat[getCurrentLocale] }}: <b>{{ pax.outward_seat.seatno | truncate(17, '...') }}</b></td>
                                <td>&nbsp;</td>
                                <td class="total-price-value-small">{{ pax.outward_seat.price !== undefined ? pax.outward_seat.price : '0' | rndAmntRUAFWZ }}</td>
                            </tr>

                            <tr v-for="(srvcs, index2) in pax.outward_srvcs" v-bind:key="index2"> <!-- out services -->
                                <td>{{ srvcs.description }}</td>
                                <td style="text-transform: none;"><span v-if="srvcs.userInputSrvcsDetails_Count > 1">{{ srvcs.userInputSrvcsDetails_Count }}x a {{ srvcs.price | rndAmntRUAFWZ }}</span></td>
                                <td class="total-price-value-small">-</td>
                            </tr>
                        </tbody>
                    </table>

                    <table v-if="flightdirection === 'return'"> <!-- ret -->
                        <tbody>
                            <tr> <!-- ret flight  -->
                                <td v-if="modulo === 'booking'">{{ flightprice[getCurrentLocale] }}</td>
                                <td v-if="modulo === 'services'">{{ flightpriceservices[getCurrentLocale] }}</td>
                                <td>&nbsp;</td>
                                <td class="total-price-value-small" v-if="modulo === 'booking'">{{ pax.return.totalprice !== undefined ? pax.return.totalprice : '0' | rndAmntRUAFWZ }}</td>
                                <td class="total-price-value-small" v-if="modulo === 'services'"> - </td>

                            </tr>

                            <tr v-if="pax.return_seat.seatno !== undefined"> <!-- ret seat  -->
                                <td>{{ seat[getCurrentLocale] }}: <b>{{ pax.return_seat.seatno | truncate(17, '...') }}</b></td>
                                <td>&nbsp;</td>
                                <td class="total-price-value-small">{{ pax.return_seat.price !== undefined ? pax.return_seat.price : '0' | rndAmntRUAFWZ }}</td>
                            </tr>

                            <tr v-for="(srvcs, index2) in pax.return_srvcs" v-bind:key="index2"> <!-- ret services -->
                                <td>{{ srvcs.description }}</td>
                                <td style="text-transform: none;"><span v-if="srvcs.userInputSrvcsDetails_Count > 1">{{ srvcs.userInputSrvcsDetails_Count }}x a {{ srvcs.price | rndAmntRUAFWZ }}</span></td>
                                <td class="total-price-value-small">-</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>


        <!-- >>> 'Total' Part (OUT/RET) -->
        <div class="booking-details sdr-box" style="padding-left: 0px; padding-right: 0px;" v-if="flightdirection === 'outward'"> <!-- out -->
            <article class="detailed-logo" style="padding: 0px;">
                <div class="details">
                    <dl class="other-details">
                        <dt class="total-price">{{ totaloutwardprice[getCurrentLocale] }}:</dt><dd class="total-price-value">{{ getBookingCartOutwardTotal | rndAmntRUAFWZ }}</dd> <!-- out -->
                    </dl>
                </div>
            </article>
        </div>

        <div class="booking-details sdr-box" style="padding-left: 0px; padding-right: 0px;" v-if="flightdirection === 'return'"> <!-- ret -->
            <article class="detailed-logo" style="padding: 0px;">
                <div class="details">
                    <dl class="other-details">
                        <dt class="total-price">{{ totalreturnprice[getCurrentLocale] }}:</dt><dd class="total-price-value">{{ getBookingCartReturnTotal | rndAmntRUAFWZ }}</dd> <!-- out -->
                    </dl>
                </div>
            </article>
        </div>
        <!-- >>> 'Total' Part (OUT/RET) -->
        <!-- <<< 'Pax&Srvcs' Part (OUT/RET)-->
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { mapMutations } from 'vuex';
    import { mapActions } from 'vuex';
    import moment from 'moment';


    export default {

        /* >>> *************************************************************** / /* Props */
        props: ['flightdirection', 'modulo'], // via: router/push
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components: {
        }, // eof components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                // >>> --------------------------
                outwardflight: {
                    en: 'Outward',
                    de: 'Hinflug'
                },
                returnflight: {
                    en: 'Return',
                    de: 'Rückfliug'
                },
                tab_flightdetails: {
                    en: 'Flight Details',
                    de: 'Flug Details'
                },
                tab_inflightfeatures: {
                    en: 'Inflight Features',
                    de: 'Funktionen an Bord'
                },
                tab_baggage: {
                    en: 'Baggage',
                    de: 'Gepäck'
                },
                tab_farerules: {
                    en: 'Fare Rules',
                    de: 'Tarifbestimmungen'
                },
                from: {
                    en: 'From',
                    de: 'Von'
                },
                to: {
                    en: 'to',
                    de: 'nach'
                },
                tab_header_flightdetailsoutward: {
                    en: 'Your flight and booking details for the outbound flight',
                    de: 'Ihre Flug- und Buchungsdetails zum Hinflug'
                },
                tab_header_flightdetailsreturn: {
                    en: 'Your flight and booking details for the inbound flight',
                    de: 'Ihre Flug- und Buchungsdetails zum Rückflug'
                },
                tab_header_flightdetailsoutwardservices: {
                    en: 'Your booking details for the outbound flight',
                    de: 'Ihre Buchungsdetails zum Hinflug'
                },
                tab_header_flightdetailsreturnservices: {
                    en: 'Your booking details for the inbound flight',
                    de: 'Ihre Buchungsdetails zum Rückflug'
                },
                tab_header_inflightfeatures: {
                    en: 'For your well-being on board',
                    de: 'Für Ihr Wohlbefinden an Bord'
                },
                tab_header_farerulesforyourflight: {
                    en: 'Fare Rules for your Flight',
                    de: 'Tarifregeln für Ihren Flug'
                },
                // >>> --------------------------
                adult: {
                    en: 'Adult',
                    de: 'Erwachsener',
                },
                child: {
                    en: 'Child',
                    de: 'Kind',
                },
                infant: {
                    en: 'Infant',
                    de: 'Kleinkind',
                },
                // >>> --------------------------
                takeoff: {
                    en: 'Take off',
                    de: 'Abflug',
                },
                landing: {
                    en: 'Landing',
                    de: 'Ankunft',
                },
                // >>> --------------------------
                airline: {
                    en: 'Airline',
                    de: 'Airline',
                },
                flighttype: {
                    en: 'Flight Type',
                    de: 'Tarif',
                },
                cancellation: {
                    en: 'Name Change',
                    de: 'Namen ändern',
                },
                flightchange: {
                    en: 'Flight Change',
                    de: 'Umbuchung',
                },
                seatsandbaggage: {
                    en: 'Seats & Baggage',
                    de: 'Sitze & Gepäck',
                },
                extracharge: {
                    en: 'Extra Charge',
                    de: 'Aufpreis'
                },
                avgpers: {
                    en: 'AVG/PAX',
                    de: 'PRO PAX'
                },
                // >>> --------------------------
                mr: {
                    en: 'Mr',
                    de: 'Herr',
                },
                mrs: {
                    en: 'Mrs',
                    de: 'Frau',
                },
                chd: {
                    en: 'Child',
                    de: 'Kind',
                },
                inf: {
                    en: 'Infant',
                    de: 'Kleinkind',
                },
                // >>> --------------------------
                born: {
                    en: 'Born',
                    de: 'Geb. am',
                },
                // >>> --------------------------
                travelerinformation: {
                    en: 'Traveler Information',
                    de: 'Reisende Infos',
                },
                payment: {
                    en: 'Your Payment details',
                    de: 'Ihre Zahlungsdetails',
                },
                paymentmethod : {
                    en: 'Your Payment method',
                    de: 'Ihre Zahlungsmethode',
                },
                forsecurity: {
                    en: 'For security reasons we do not write out your complete payment data here.',
                    de: 'Aus Sicherheitsgründen schreiben wir hier Ihre kompletten Zahlungsdaten nicht aus.',
                },
                paymentismadeby : {
                    en: 'Payment is made by ',
                    de: 'Die Zahlung erfolgt durch ',
                },
                creditcard: {
                    en: 'Creditcard',
                    de: 'Kreditkarte',
                },
                debit: {
                    en: 'Direct Debit',
                    de: 'Überweisung',
                },
                payment_firstname: {
                    en: 'FIRST NAME',
                    de: 'Vorname',
                },
                payment_lastname: {
                    en: 'LAST NAME',
                    de: 'Nachname',
                },
                payment_email: {
                    en: 'E-MAIL ADDRESS',
                    de: 'E-Mail',
                },
                payment_phone: {
                    en: 'Phone',
                    de: 'Telefon',
                },
                payment_address: {
                    en: 'STREET ADDRESS AND NUMBER',
                    de: 'Adresse',
                },
                payment_zipcode: {
                    en: 'ZIP CODE',
                    de: 'PLZ',
                },
                payment_city: {
                    en: 'TOWN / CITY',
                    de: 'Wohnort',
                },
                payment_countrycode: {
                    en: 'COUNTRY',
                    de: 'Land',
                },
                // >>> --------------------------
                pleaseconfirm: {
                    en: 'Please confirm',
                    de: 'Bitte bestätigen Sie',
                },
                flightprice : {
                    en: 'Flight price',
                    de: 'Flugpreis',
                },
                flightpriceservices: {
                    en: 'Flight already booked',
                    de: 'Flug schon gebucht',
                },
                tincludedtaxes: {
                    en: 'incl. Taxes, Fees & Surcharges',
                    de: 'inkl. Steuern, Gebühren & Zuschlägen',
                },
                total : {
                    en: 'Total',
                    de: 'Gesamt',
                },
                totaloutwardprice: {
                    en: 'Total Outward',
                    de: 'Gesamt Hinflug',
                },
                totalreturnprice: {
                    en: 'Total Return',
                    de: 'Gesamt Rückflug',
                },
                seat: {
                    en: 'Seat',
                    de: 'Sitz',
                },
                // currentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                // >>> --------------------------
                'getFlagBookingOverviewIsReadyForProcess',
                // 'getBookingProcessBookingObject',
                'getBookingFlightIdSelectedReturn', // got RET Flight?
                'getBookingDepArprtName',
                'getBookingDesArprtName',
                'getBookingCart', // Pax per Pax
                'getBookingLockfaresResults',
                'getBookingCartOutwardTotal', // Summed up Outward ALL
                'getBookingCartReturnTotal', // Summed up Return ALL
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Filters */
        filters: {

            /*******************************************************************
            * dateFlightCart()
            *
            * Desc:
            *
            * @param {string} date (Date to reformat)
            * @return {string}
            */
            dateFlightCart: function(date) {

                return moment(date, moment.ISO_8601).format('DD.MM.YYYY'); // de:
                // return moment(date, moment.ISO_8601).format('MMM DD, YYYY'); // en: JAN 30, 2019

            }, // dateFlightCart()

            /*******************************************************************
            * durationFlightCart()
            *
            * Desc: Calculates "Travel Time".
            *
            * @param {int} a (duration in seconds)
            * @return {string}
            */
            durationFlightCart: function(a) {

                let hours = Math.floor(a / 3600),
                    minutes = Math.floor(a / 60) - hours * 60,
                    hours_txt = 'S', // H
                    minutes_txt = ' h'; // M


                if (minutes === 0) {
                    return hours + ':00' + minutes_txt;
                } else if (minutes.toString().length === 1) {
                    return hours + ':0' + minutes + '' + minutes_txt;
                } else {
                    return hours + ':' + minutes + '' + minutes_txt;
                }

            }, // eof durationFlightCart()

        }, // eof filters{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * trnslPaxTypes()
            *
            * Desc:
            *
            * @param
            * @return {Array}
            */
            trnslPaxTypes: function(type) {

                var me = this,
                    trnsltdType = '';


                me.$toc('>>> booking/overview/FlightDetails.vue >>> trnslPaxTypes');
                switch(type) {
                case 'ADT':
                    trnsltdType = me.adult[me.getCurrentLocale];
                    break;
                case 'CHD':
                    trnsltdType = me.child[me.getCurrentLocale];
                    break;
                case 'INF':
                    trnsltdType = me.infant[me.getCurrentLocale];
                    break;
                default:
                    trnsltdType = '';
                }


                return trnsltdType;

            }, // eof trnslPaxTypes()

            /*******************************************************************
            * trnslPaxSalutations()
            *
            * Desc:
            *
            * @param
            * @return {Array}
            */
            trnslPaxSalutations: function(type) {

                var me = this,
                    trnsltdSalutation = '';


                me.$toc('>>> booking/overview/FlightDetails.vue >>> trnslPaxSalutations');
                switch(type) {
                case 'MR':
                    trnsltdSalutation = me.mr[me.getCurrentLocale];
                    break;
                case 'MRS':
                    trnsltdSalutation = me.mrs[me.getCurrentLocale];
                    break;
                case 'CHD':
                    trnsltdSalutation = me.chd[me.getCurrentLocale];
                    break;
                case 'INF':
                    trnsltdSalutation = me.inf[me.getCurrentLocale];
                    break;
                default:
                    trnsltdSalutation = '';
                }


                return trnsltdSalutation;

            }, // eof trnslPaxSalutations()

        }, // eof methods()
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    #flight-details .flights {
        padding-bottom: 0px;
    }
    #flight-details .flights .first-flight .logo:after {
        bottom: 23px;
    }


    .totalbutton {
        padding-right: 7px;
        height: 43px;
        font-size: 1.6667em; /* 1.4167em, 1.1667em; 1.6667em */
        line-height: 15px;
        text-align: right;
        height: 57px;
    }
    dl.term-description dt {
        color: #9e4d84;
    }
    .tab-container ul.tabs li.active > a, .tab-container ul.tabs li:hover > a {
        color: #9e4d84;
    }

    /* Price Table */
    .cruise-itinerary td {
        line-height: 2.5em;
        border: 1px solid #f5f5f5;
    }
    .booking-details .other-details {
        background-color: #F5F5F5;
    }
    .booking-details .other-details .total-price-value {
        font-size:1.9167em
    }
    .total-price-value-small {
        color: #98ce44;
        font-size: 1.4em;
        text-align: right;
    }
    .booking-details .other-details dt, .booking-details .other-details dd {
        padding-top: 0.4em;
        padding-bottom: 0.4em;
    }

    .icon-box.style9 > i {
        background: #9e4d84;
    }

    .hotel-faqs .topics li.active, #flight-fare-rules .topics li.active {
        background: #9e4d84;
    }





    /* >>> SearchResult iPAD -------------------------------------------------*/
    @media only screen
    and (min-device-width : 768px)
    and (max-device-width : 1024px)  {
        h1 {
            font-size: 1.5em;
        }
        h2 {
            font-size: 1.4em;
        }
        button.btn-large, input[type="button"].button.btn-large, a.button.btn-large {
            font-size: 1.0em;
        }

        .booking-section {
            padding-top: 20px;
            padding-right: 15px;
            padding-bottom: 20px;
            padding-left: 15px;
        }
    }
</style>